import { createContext, useContext } from 'react';

export const ActiveEventContext = createContext(null);
export const useActiveEvent = () => useContext(ActiveEventContext);
